import { Text } from '@mantine/core';
import { SINGLE_LINE_STYLE } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/singleLine.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { makeComplexDataTestId, TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { InvestorDocumentRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DocumentsCard/investorDocuments.types.ts';
import { LinkedToNames } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DocumentsCard/LinkedToNames.tsx';

interface Props {
	document: InvestorDocumentRow;
	onPreview: (document: InvestorDocumentRow) => void;
}

export const DocumentCardItem = ({ document, onPreview }: Props) => {
	const tMipManage = useTranslationMipManage();
	const linkTypeLabel = document.isTransactionDocument
		? tMipManage('investors.details.documents.link_type.transaction')
		: tMipManage('investors.details.documents.link_type.programme');

	return (
		<button
			type="button"
			className="document"
			onClick={() => onPreview(document)}
			data-testid={makeComplexDataTestId(
				TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_DOCUMENT_CARD,
				document.id
			)}
		>
			<Icon variant="document-v3" size="xl" />

			<div className="details">
				<Text
					fz={14}
					fw={600}
					c="dark.8"
					truncate
					style={SINGLE_LINE_STYLE}
					title={document.name}
				>
					{document.name}
				</Text>

				{!!document.classifications && (
					<Text fz={14} c="dark.0" truncate>
						{document.classifications}
					</Text>
				)}

				{document.linkedToNames.length > 0 ? (
					<LinkedToNames
						names={document.linkedToNames}
						suffix={`· ${linkTypeLabel}`}
						textProps={{ fz: 12, c: 'dark.0' }}
					/>
				) : (
					<Text fz={12} c="dark.0" truncate style={SINGLE_LINE_STYLE}>
						{linkTypeLabel}
					</Text>
				)}
			</div>
		</button>
	);
};
